import { Attraction } from '../types';
const imgTulum = '/media/ruinas-tulum/ruinas-tulum.webp';
const imgChichen = '/media/chichen-itza/chichen-itza-1.webp';
const imgXpuHa = '/media/xpu-ha/xpu-ha.webp';
const imgAkumal = '/media/akumal/tortugas.webp';
const imgCenoteAzul = '/media/cenote-azul/cenote-azul.webp';
const imgChaakTun = '/media/cenote-chaak-tun/cenote-chaak-tun.webp';
const imgQuintaAv = '/media/playa-del-carmen/playa-del-carmen.webp';
const imgCoba = '/media/coba/coba.webp';
const imgCristalino = '/media/cenote-cristalino/cenote-cristalino.webp';
const imgJardinEden = '/media/cenote-jardin-del-eden/cenote-jardin-del-eden-37497c34.webp';
const imgPuertoMorelos = '/media/native-park-puerto-morelos/native-park-puerto-morelos.webp';
const imgPlayaDelfines = '/media/cancun/cancun.webp';
const imgLaIsla = '/media/la-isla-shopping-village/la-isla-shopping-village.webp';
const imgMarinaPuertoCancun = '/media/marina-puerto-cancun/marina-puerto-cancun.webp';
const imgMercado28 = '/media/mercado-28/mercado-28.webp';
const imgParquePalapas = '/media/parque-de-las-palapas/parque-de-las-palapas.webp';
const imgMariscosMercado28 = '/media/marisqueria-el-cejas/marisqueria-el-cejas.webp';
const imgPlayaTortugas = '/media/playa-tortugas/playa-tortugas.webp';
const imgMandalaBeach = '/media/mandala-beach-club/mandala-beach-club.webp';
const imgIslaBlanca = '/media/isla-blanca/isla-blanca.webp';
const imgVidaNocturna = '/media/vida-nocturna/vida-nocturna.webp';
const imgLagunaNichupte = '/media/laguna-nichupte-sunset/laguna-nichupte-sunset.webp';
const imgTacosPastor = '/media/tacos-al-pastor/tacos-al-pastor.webp';

export const ATTRACTIONS: Attraction[] = [
  // --- PLAYAS LOCALES DE CANCÚN ---
  {
    id: 'playa-delfines',
    title: 'Playa Delfines & El Mirador (Letras de Cancún)',
    category: 'playas',
    tag: 'Local Cancún & Mirador Icónico',
    shortDescription: 'La playa pública más emblemática de Cancún: inmensas olas turquesas, el mirador escénico y el parador fotográfico.',
    fullDescription: 'Ubicada en el Km 19.5 del Boulevard Kukulcán en la Zona Hotelera. Conocida popularmente como "El Mirador", Playa Delfines cuenta con la prestigiosa certificación Blue Flag, palapas gratuitas de palma, mirador con vistas espectaculares al Caribe y las célebres letras monumentales de Cancún para la foto indispensable de tus vacaciones.',
    image: imgPlayaDelfines,
    distanceFromCancun: 'Km 19.5 Zona Hotelera (15-20 min en auto)',
    drivingTimeMinutes: 18,
    whyByCar: 'Los camiones urbanos suelen ir saturados en horas pico. Con tu auto de Easy Way llegas temprano, llevas tus toallas, sillas y hielera en la cajuela y aprovechas el amplio estacionamiento gratuito habilitado.',
    parkingInfo: 'Estacionamiento público gratuito y vigilado frente a la playa sobre Blvd. Kukulcán.',
    bestTime: '08:00 - 11:00 AM (vista despejada, sol brillante y fotos sin fila)',
    priceRange: 'Gratis',
    rating: 4.9,
    highlight: 'Letrero monumental de Cancún y mirador panorámico del Caribe',
    mapQuery: 'Playa Delfines Cancun'
  },
  {
    id: 'playa-tortugas-cancun',
    title: 'Playa Tortugas & Arrecife (Zona Hotelera)',
    category: 'playas',
    tag: 'Local Cancún & Mar Tranquilo',
    shortDescription: 'Aguas cristalinas y bajas sin oleaje fuerte en el Km 6.5, muelle panorámico y deportes acuáticos.',
    fullDescription: 'Playa Tortugas es una de las playas favoritas de familias y viajeros en Cancún por sus aguas tranquilas estilo alberca natural. Cuenta con muelle panorámico, renta de motos acuáticas, salto en bungy de 25 metros frente al mar, restaurantes de mariscos y terminal de ferry a Isla Mujeres.',
    image: imgPlayaTortugas,
    distanceFromCancun: 'Km 6.5 Zona Hotelera (10 min en auto)',
    drivingTimeMinutes: 10,
    whyByCar: 'Rápido y cómodo acceso sobre el Boulevard Kukulcán; puedes estacionar tu auto y tener la libertad de moverte entre diferentes playas del día a tu propio ritmo.',
    parkingInfo: 'Estacionamiento público con tarifa accesible en el acceso al muelle.',
    bestTime: '09:00 AM - 02:00 PM',
    priceRange: 'Gratis',
    rating: 4.7,
    highlight: 'Mar calmo como alberca, bungy jump y snorkel',
    mapQuery: 'Playa Tortugas Cancun'
  },
  {
    id: 'isla-blanca-cancun',
    title: 'Isla Blanca & Costa Mujeres (Caribe Virgen)',
    category: 'playas',
    tag: 'Local Cancún & Paraíso Virgen',
    shortDescription: 'Extensa península virgen de arena blanca entre el Mar Caribe y la Laguna Chacmuchuch al norte de Cancún.',
    fullDescription: 'A solo 25 minutos al norte de Cancún pasando Puerto Juárez y Playa Mujeres. Isla Blanca es una estrecha franja de arena virgen sin hoteles masivos donde por un lado rompe el mar turquesa y por el otro la apacible laguna. Es el santuario predilecto para amantes de la naturaleza, kitesurf y atardeceres dorados.',
    image: imgIslaBlanca,
    distanceFromCancun: '24 km al norte de Cancún (30 min en auto)',
    drivingTimeMinutes: 30,
    whyByCar: 'No hay transporte público regular hasta la punta de Isla Blanca. Un auto rentado en Easy Way es imprescindible para llegar con hielera, sombrilla y comida para disfrutar todo el día.',
    parkingInfo: 'Áreas de estacionamiento rústico sobre la arena y clubes de playa locales.',
    bestTime: '10:00 AM - 06:30 PM (atardecer de ensueño sobre la laguna)',
    priceRange: 'Gratis',
    rating: 4.9,
    highlight: 'Arena virgen entre el mar abierto y la laguna Chacmuchuch',
    mapQuery: 'Isla Blanca Cancun'
  },
  // --- PLAYAS FORÁNEAS (CONSERVADAS) ---
  {
    id: 'playa-xpu-ha',
    title: 'Playa Xpu-Há (Bahía Virgen)',
    category: 'playas',
    tag: 'Excursión Foránea (Riviera Maya)',
    shortDescription: 'Una de las bahías más hermosas de la Riviera Maya: arena blanca talco, arrecife cercano y aguas tranquilas.',
    fullDescription: 'Ubicada en la Riviera Maya al sur de Cancún por la Carretera Federal 307. Xpu-Há conserva una atmósfera relajada lejos de los rascacielos hoteleros. Cuenta con clubes de playa rústicos, renta de kayaks, paddleboard y una barrera coralina a 100 metros nadando repleta de peces tropicales y mantarrayas.',
    image: imgXpuHa,
    distanceFromCancun: '95 km al sur de Cancún (1h 15m en auto)',
    drivingTimeMinutes: 75,
    whyByCar: 'En colectivo te dejan a orilla de la carretera y debes caminar más de 1 km bajo el sol. Con tu auto de Easy Way llegas directo a la orilla del mar con todas tus pertenencias y hielera.',
    parkingInfo: 'Estacionamiento sombreado bajo palmeras dentro del club de playa ($50-$100 MXN reembolsables en consumo).',
    bestTime: '09:00 AM - 04:00 PM',
    priceRange: '$',
    rating: 4.9,
    highlight: 'Aguas cristalinas estilo piscina natural caribeña',
    mapQuery: 'Playa Xpu-Ha Quintana Roo'
  },
  {
    id: 'akumal-tortugas',
    title: 'Bahía de Akumal (Santuario de Tortugas)',
    category: 'playas',
    tag: 'Excursión Foránea (Riviera Maya)',
    shortDescription: 'Nada con tortugas marinas verdes en su hábitat protegido y admira el segundo arrecife más grande del mundo.',
    fullDescription: 'Akumal ("Lugar de las Tortugas" en maya) es un área marina protegida donde decenas de tortugas se alimentan de pasto marino a pocos metros de la orilla. El agua es sumamente cristalina y cálida. Los tours organizados cobran sumas excesivas por persona, pero conduciendo tu auto solo pagas el acceso al parque marino.',
    image: imgAkumal,
    distanceFromCancun: '105 km al sur de Cancún (1h 20m en auto)',
    drivingTimeMinutes: 80,
    whyByCar: 'Llegar a las 8:30 AM saliendo desde Cancún te garantiza nadar con tortugas con visibilidad perfecta del agua y antes de que lleguen los autobuses de excursionistas masivos.',
    parkingInfo: 'Estacionamientos vigilados en la entrada de la bahía de Akumal ($50 MXN tiempo libre).',
    bestTime: '08:00 - 10:30 AM',
    priceRange: '$$',
    rating: 4.9,
    highlight: 'Tortugas marinas a 2 metros de distancia en su hábitat',
    mapQuery: 'Akumal Bay Quintana Roo'
  },

  // --- CENOTES (RUTA LOCAL Y FORÁNEOS) ---
  {
    id: 'ruta-de-los-cenotes',
    title: 'Ruta de los Cenotes (Puerto Morelos - Cancún)',
    category: 'cenotes',
    tag: 'Cenotes más Cercanos a Cancún',
    shortDescription: 'Corredor ecológico de 35 km con más de 15 cenotes de caverna y cielo abierto, tirolesas y cuatrimotos.',
    fullDescription: 'Es el circuito de cenotes más cercano y accesible desde Cancún (a solo 35 minutos al sur). Sobre esta carretera selvática se descubren joyas como Cenote Verde Lucero, Boca del Puma, Cenote Siete Bocas y Parque Selvática. Con aguas cristalinas frescas, clavados y tirolesas que atraviesan la selva.',
    image: imgPuertoMorelos,
    distanceFromCancun: '38 km al sur de Cancún (32 min en auto)',
    drivingTimeMinutes: 32,
    whyByCar: 'La Ruta de los Cenotes mide más de 30 kilómetros de selva virgen sin transporte público regular. Tener auto con kilometraje ilimitado de Easy Way te permite saltar entre 3 o 4 cenotes distintos en un solo día sin sobrecostos.',
    parkingInfo: 'Cada cenote cuenta con amplio estacionamiento propio con sombra natural.',
    bestTime: '09:00 AM - 03:00 PM',
    priceRange: '$$',
    rating: 4.9,
    highlight: 'Tirolesas y múltiples cenotes sobre una misma carretera escénica',
    mapQuery: 'Ruta de los Cenotes Puerto Morelos'
  },
  {
    id: 'cenote-azul',
    title: 'Cenote Azul (Riviera Maya)',
    category: 'cenotes',
    tag: 'Excursión Foránea (Cenote Abierto)',
    shortDescription: 'Inmenso cenote abierto con piscinas naturales de distintas profundidades, saltos desde risco y peces exfoliantes.',
    fullDescription: 'Uno de los cenotes más espectaculares y familiares de Quintana Roo. El agua es color azul turquesa brillante, rodeada de abundante vegetación selvática. Cuenta con áreas bajas aptas para niños y una plataforma de salto de 4 metros para los más intrépidos. Los pececillos de agua dulce te dan una exfoliación natural en los pies al entrar al agua.',
    image: imgCenoteAzul,
    distanceFromCancun: '92 km al sur de Cancún (1h 10m en auto)',
    drivingTimeMinutes: 70,
    whyByCar: 'Saliendo desde Cancún por la Carretera 307 llegas en poco más de una hora y puedes combinarlo el mismo día con Cenote Cristalino y Playa Xpu-Há sin gastar fortunas en taxis interurbanos.',
    parkingInfo: 'Estacionamiento amplio y gratuito dentro de las instalaciones del cenote.',
    bestTime: '09:00 - 11:30 AM (menos gente, luz solar cenital perfecta)',
    priceRange: '$',
    rating: 4.9,
    highlight: 'Saltos de roca y agua cristalina transparente en la selva',
    mapQuery: 'Cenote Azul Riviera Maya'
  },
  {
    id: 'cenote-cristalino',
    title: 'Cenote Cristalino',
    category: 'cenotes',
    tag: 'Excursión Foránea (Semiabierto con Manglar)',
    shortDescription: 'Paredes rocosas esculpidas, cueva escondida para nadar y aguas esmeraldas de máxima pureza.',
    fullDescription: 'Vecino del Cenote Azul, Cristalino destaca por su pintoresco túnel de cueva subterránea por donde puedes nadar entre estalagmitas sumergidas. Rodeado de manglares y ceibas gigantes, ofrece alquiler de chalecos salvavidas, snorkel y palapas para descansar.',
    image: imgCristalino,
    distanceFromCancun: '91 km al sur de Cancún (1h 10m en auto)',
    drivingTimeMinutes: 70,
    whyByCar: 'Viajar en auto te permite guardar tus toallas secas, cambio de ropa y calzado en la cajuela y explorar a tu ritmo sin prisas.',
    parkingInfo: 'Estacionamiento vigilado incluido con tu entrada.',
    bestTime: '09:30 AM - 01:30 PM',
    priceRange: '$',
    rating: 4.8,
    highlight: 'Túnel de cueva sumergida para explorar',
    mapQuery: 'Cenote Cristalino Quintana Roo'
  },
  {
    id: 'cenote-jardin-del-eden',
    title: 'Cenote Jardín del Edén (Ponderosa)',
    category: 'cenotes',
    tag: 'Excursión Foránea (Buceo & Clavados)',
    shortDescription: 'Una piscina natural colosal en medio de la selva maya, ideal para saltos de 5 metros y snorkel profundo.',
    fullDescription: 'Verdadero paraíso verde con un área central profunda de aguas color esmeralda donde se practican cursos de buceo de caverna. En el fondo descansan enormes rocas cubiertas de musgo que crean un paisaje submarino extraterrestre. Cuenta con plataforma de madera para saltos emocionantes.',
    image: imgJardinEden,
    distanceFromCancun: '93 km al sur de Cancún (1h 12m en auto)',
    drivingTimeMinutes: 72,
    whyByCar: 'Ir en auto te da la libertad de llegar con equipo de buceo o snorkel pesado sin depender de horarios de colectivos.',
    parkingInfo: 'Estacionamiento de terracería compacta vigilado en la entrada.',
    bestTime: '10:00 AM - 02:00 PM',
    priceRange: '$',
    rating: 4.8,
    highlight: 'Plataforma alta de clavados y caverna de buceo',
    mapQuery: 'Cenote Jardin del Eden'
  },
  {
    id: 'cenote-chaak-tun',
    title: 'Cenote Chaak Tun (Cavernas de Playa del Carmen)',
    category: 'cenotes',
    tag: 'Excursión Foránea (Caverna Sagrada)',
    shortDescription: 'Espectaculares cavernas sagradas mayas con estalactitas y estalagmitas milenarias.',
    fullDescription: 'Chaak Tun es una de las cavernas inundadas más impresionantes y accesibles de Quintana Roo. Camina y nada con linterna sumergible entre formaciones minerales de millones de años iluminadas tenuemente con antorchas y luz natural a través de claraboyas de la selva. Un encuentro místico con el inframundo maya (Xibalbá).',
    image: imgChaakTun,
    distanceFromCancun: '72 km al sur de Cancún (1h 05m en auto)',
    drivingTimeMinutes: 65,
    whyByCar: 'Llegar en auto rentado desde Cancún por la autopista/carretera 307 te permite llegar directo sin necesidad de pagar taxis especiales de selva.',
    parkingInfo: 'Estacionamiento cerrado con seguridad en el lobby.',
    bestTime: '10:00 AM - 03:00 PM (guiado)',
    priceRange: '$$',
    rating: 4.9,
    highlight: 'Miles de estalactitas milenarias sobre tu cabeza',
    mapQuery: 'Cenote Chaak Tun Playa del Carmen'
  },

  // --- VIDA NOCTURNA & FIESTAS LOCALES DE CANCÚN ---
  {
    id: 'punta-cancun-party-center',
    title: 'Punta Cancún & Party Center (Km 9.5)',
    category: 'vida-nocturna',
    tag: 'Local Cancún & Antros Legendarios',
    shortDescription: 'El epicentro mundial de la fiesta en Cancún: Coco Bongo, The City, Mandala, Dady\'O y Abolengo.',
    fullDescription: 'En el corazón de la Zona Hotelera de Cancún (Km 9.5), Punta Cancún reúne los centros nocturnos más aclamados del continente. Coco Bongo Cancún deslumbra con acróbatas aéreos y shows cinematográficos en vivo, mientras The City (el club más grande de América Latina) recibe a los DJs internacionales más cotizados. Una atmósfera electrizante frente al mar.',
    image: imgVidaNocturna,
    distanceFromCancun: 'Km 9.5 Zona Hotelera (10-15 min en auto)',
    drivingTimeMinutes: 12,
    whyByCar: 'Los taxis nocturnos en la Zona Hotelera cobran tarifas desorbitadas sin regulación. Con tu auto puedes dejarlo seguro en los estacionamientos techados 24/7 de Plaza Forum o Plaza Caracol y regresar cómodo a tu hotel.',
    parkingInfo: 'Estacionamientos techados vigilados 24 horas en Plaza Forum by the Sea y Plaza Caracol.',
    bestTime: '10:30 PM - 05:00 AM',
    priceRange: '$$$',
    rating: 4.9,
    highlight: 'Show monumental de Coco Bongo y los antros más grandes de América Latina',
    mapQuery: 'Coco Bongo Cancun'
  },
  {
    id: 'mandala-beach-club-cancun',
    title: 'Mandala Beach Club Cancún (Fiesta de Día)',
    category: 'vida-nocturna',
    tag: 'Local Cancún & Beach Pool Party',
    shortDescription: 'El club de playa más exclusivo de Cancún con alberca frente al mar, jacuzzis, DJs y noche de alberca.',
    fullDescription: 'Ubicado en la mejor playa de Punta Cancún, Mandala Beach combina el lujo caribeño con la energía de la música electrónica y tropical. Disfruta de camas balinesas, servicio de coctelería premium, camastros frente al mar turquesa y su icónica Tuesday Pool Party nocturna bajo las estrellas del Caribe.',
    image: imgMandalaBeach,
    distanceFromCancun: 'Km 9.5 Zona Hotelera (10 min en auto)',
    drivingTimeMinutes: 10,
    whyByCar: 'Llega fresco con el aire acondicionado de tu auto de Easy Way y cambia tu ropa de playa por ropa de noche sin depender de transportes ajenos.',
    parkingInfo: 'Estacionamiento techado a 50 metros en Plaza Forum by the Sea.',
    bestTime: '12:00 PM - 07:00 PM (y martes en la noche)',
    priceRange: '$$$',
    rating: 4.7,
    highlight: 'Fiesta de alberca frente a las aguas más azules de Cancún',
    mapQuery: 'Mandala Beach Club Cancun'
  },
  {
    id: 'zona-restaurantes-laguna-nichupte',
    title: 'Laguna Nichupté: Terrazas & Sunset Lounges (Km 12 - 14)',
    category: 'vida-nocturna',
    tag: 'Local Cancún & Mixología Romántica',
    shortDescription: 'Restaurantes y lounges icónicos sobre la laguna: Lorenzillo\'s, Puerto Madero, RosaNegra e Ilios al atardecer.',
    fullDescription: 'Sobre el lado de la laguna Nichupté en la Zona Hotelera se concentran los restaurantes y lounges más exclusivos de México. Disfruta de shows con fuego, fuegos artificiales, saxofón en vivo, langosta fresca y alta mixología con vistas espectaculares a la puesta de sol dorada sobre la laguna.',
    image: imgLagunaNichupte,
    distanceFromCancun: 'Km 12.5 Zona Hotelera (12 min en auto)',
    drivingTimeMinutes: 12,
    whyByCar: 'El corredor de la laguna es amplio; tener auto te permite elegir el restaurante y lounge que prefieras y moverte con total comodidad.',
    parkingInfo: 'Servicio de Valet Parking en todos los restaurantes sobre Blvd. Kukulcán.',
    bestTime: '06:30 PM - 12:00 AM (atardecer mágico sobre el agua)',
    priceRange: '$$$',
    rating: 4.9,
    highlight: 'Atardeceres dorados sobre la laguna con shows en vivo y mixología',
    mapQuery: 'Restaurantes Laguna Nichupte Cancun'
  },
  {
    id: 'calle-12-playa-foranea',
    title: 'Noches en Playa del Carmen (Calle 12 & 5ta Av)',
    category: 'vida-nocturna',
    tag: 'Excursión Foránea (Playa del Carmen)',
    shortDescription: 'Ambiente festivo peatonal caribeño a 55 minutos de Cancún: antros al aire libre y fiesta a pasos del mar.',
    fullDescription: 'Para quienes desean experimentar la atmósfera de Playa del Carmen de noche, la Calle 12 concentra bares y discotecas a escasos metros de la playa. Con tu auto alquilado en Easy Way puedes hacer un roadtrip nocturno, disfrutar del ambiente cosmopolita y regresar seguro cuando lo decidas.',
    image: imgVidaNocturna,
    distanceFromCancun: '68 km al sur de Cancún (55 min en auto)',
    drivingTimeMinutes: 55,
    whyByCar: 'Un taxi de Cancún a Playa del Carmen de noche cobra más de $1,500 MXN por trayecto. Con tu propio auto tienes total autonomía.',
    parkingInfo: 'Estacionamientos subterráneos seguros 24 hrs en Plaza Calle Corazón sobre Av. 10.',
    bestTime: '10:30 PM - 03:30 AM',
    priceRange: '$$$',
    rating: 4.8,
    highlight: 'Ambiente peatonal y fiesta a orillas del mar en Playa del Carmen',
    mapQuery: 'Calle 12 Playa del Carmen'
  },

  // --- SHOPPING & PASEOS LOCALES DE CANCÚN ---
  {
    id: 'la-isla-shopping-village',
    title: 'La Isla Shopping Village & Rueda Gigante',
    category: 'shopping',
    tag: 'Local Cancún & Canales Navegables',
    shortDescription: 'El centro comercial al aire libre más hermoso de México: canales navegables, boutiques de lujo, acuario y rueda gigante.',
    fullDescription: 'Ubicado en el Km 12.5 de la Zona Hotelera a orillas de la Laguna Nichupté. Diseñado como una pequeña Venecia caribeña con puentes sobre canales navegables, La Isla cuenta con marcas internacionales de lujo, la Gran Rueda de Cancún (Cancun Wheel), el Acuario Interactivo y restaurantes con terrazas sobre el agua.',
    image: imgLaIsla,
    distanceFromCancun: 'Km 12.5 Zona Hotelera (12 min en auto)',
    drivingTimeMinutes: 12,
    whyByCar: 'Las bolsas de compras y souvenirs se vuelven pesadas. Tener tu auto en el estacionamiento techado te permite guardar todo de forma segura y seguir paseando por los canales.',
    parkingInfo: 'Estacionamiento techado de varios niveles vigilado con pago automatizado.',
    bestTime: '04:00 PM - 10:00 PM (clima agradable y canales iluminados)',
    priceRange: '$$$',
    rating: 4.9,
    highlight: 'Canales navegables, rueda panorámica gigante y tiendas de diseñador',
    mapQuery: 'La Isla Shopping Village Cancun'
  },
  {
    id: 'mercado-28-cancun',
    title: 'Mercado 28: Artesanías & Platería Mexicana',
    category: 'shopping',
    tag: 'Local Cancún & Cultura Popular',
    shortDescription: 'El corazón tradicional de Cancún: cientos de locales de artesanías mexicanas, platería de Taxco, souvenirs y antojitos.',
    fullDescription: 'Para conocer el Cancún auténtico y comprar artesanías a precios locales muy inferiores a la Zona Hotelera, el Mercado 28 en el centro de la ciudad es el destino indiscutible. Encuentra sombreros de charro, hamacas yucatecas, guayaberas, cerámica maya y tequila artesanal con el regateo tradicional mexicano.',
    image: imgMercado28,
    distanceFromCancun: 'En el Centro de Cancún (Supermanzana 28)',
    drivingTimeMinutes: 8,
    whyByCar: 'El transporte público del centro puede ser confuso por las supermanzanas. Con tu auto y GPS llegas directo sin perder tiempo.',
    parkingInfo: 'Estacionamiento público señalizado en el perímetro del Mercado 28.',
    bestTime: '10:00 AM - 05:00 PM',
    priceRange: '$',
    rating: 4.7,
    highlight: 'Artesanías mexicanas auténticas a precios locales sin sobreprecios',
    mapQuery: 'Mercado 28 Cancun'
  },
  {
    id: 'marina-puerto-cancun',
    title: 'Marina Puerto Cancún Town Center',
    category: 'shopping',
    tag: 'Local Cancún & Marina Náutica',
    shortDescription: 'El desarrollo náutico más vanguardista de Cancún: boutiques exclusivas, cines VIP y vista a yates de lujo.',
    fullDescription: 'Ubicado en el Km 1.5 en el cruce entre el Centro y la Zona Hotelera. Marina Town Center destaca por su arquitectura al aire libre con vista a los muelles donde atracan impresionantes yates. Ofrece tiendas departamentales, cines Cinépolis VIP y restaurantes gourmet con terrazas panorámicas.',
    image: imgMarinaPuertoCancun,
    distanceFromCancun: 'Km 1.5 Entrada Zona Hotelera (5-8 min en auto)',
    drivingTimeMinutes: 7,
    whyByCar: 'Acceso vehicular inmediato y amplio estacionamiento subterráneo techado; punto ideal de escala entre el centro y la playa.',
    parkingInfo: 'Estacionamiento techado de gran capacidad con pago electrónico.',
    bestTime: '01:00 PM - 09:30 PM',
    priceRange: '$$$',
    rating: 4.8,
    highlight: 'Vistas panorámicas a la marina de yates y gastronomía internacional',
    mapQuery: 'Marina Puerto Cancun'
  },
  {
    id: 'quinta-avenida-foranea',
    title: 'Excursión a Playa del Carmen & 5ta Avenida',
    category: 'shopping',
    tag: 'Excursión Foránea (Playa del Carmen)',
    shortDescription: 'El andador peatonal más vibrante de la Riviera Maya: 5 km de boutiques, arte, joyerías y ambiente bohemio.',
    fullDescription: 'Con más de 5 kilómetros de longitud sin autos, la Quinta Avenida es el alma turística de Playa del Carmen. Pasea entre tiendas de moda mundial, joyerías de plata, galerías de arte maya contemporáneo y cientos de restaurantes con terrazas al aire libre. Un paseo imperdible desde Cancún.',
    image: imgQuintaAv,
    distanceFromCancun: '68 km al sur de Cancún (55 min en auto)',
    drivingTimeMinutes: 55,
    whyByCar: 'Un taxi desde Cancún cuesta más de $1,200 MXN por trayecto. Con tu auto rentado en Easy Way vas y regresas cuando gustes por la rápida Carretera 307.',
    parkingInfo: 'Estacionamientos subterráneos seguros sobre la Av. 10 con Calles 8, 12 y 28.',
    bestTime: '05:30 PM - 10:30 PM (clima fresco y ambiente festivo)',
    priceRange: '$$',
    rating: 4.9,
    highlight: 'Ambiente cosmopolita, artistas callejeros y boutiques frente al mar',
    mapQuery: 'Quinta Avenida Playa del Carmen'
  },

  // --- ROADTRIPS & ALREDEDORES (DESDE CANCÚN) ---
  {
    id: 'chichen-itza-valladolid',
    title: 'Chichén Itzá & Pueblo Mágico de Valladolid',
    category: 'roadtrips',
    tag: 'Maravilla del Mundo (Yucatán)',
    shortDescription: 'Roadtrip épico por la autopista 180D hacia la pirámide de Kukulkán, gastronomía yucateca y cenote Ik Kil.',
    fullDescription: 'Conducir desde Cancún hasta Chichén Itzá es sumamente directo, rápido y seguro por la moderna autopista de cuota 180D. Visita la pirámide del Dios Serpiente Emplumada, el Observatorio astronómico y el Gran Juego de Pelota. De regreso, haz escala en el Pueblo Mágico de Valladolid para comer cochinita pibil y marquesitas en el zócalo.',
    image: imgChichen,
    distanceFromCancun: '195 km al oeste de Cancún (2h 15m por autopista)',
    drivingTimeMinutes: 135,
    whyByCar: 'Los tours organizados cobran $120-$160 USD por persona y te encierran 12 horas en un autobús con 50 extraños. Con tu auto alquilado en Easy Way sales a las 6:30 AM, llegas antes que los autobuses turísticos y ahorras cientos de dólares en familia.',
    parkingInfo: 'Estacionamiento pavimentado con vigilancia en el parador turístico de Chichén Itzá ($80 MXN).',
    bestTime: '08:00 AM (apertura del sitio arqueológico sin multitudes)',
    priceRange: '$$$',
    rating: 5.0,
    highlight: 'La maravilla del mundo a tu propio ritmo y sin prisas',
    mapQuery: 'Chichen Itza Yucatan'
  },
  {
    id: 'tulum-ruinas-paraiso',
    title: 'Ruinas de Tulum & Playa Paraíso en Auto',
    category: 'roadtrips',
    tag: 'Excursión Foránea (Riviera Maya)',
    shortDescription: 'La única ciudad amurallada maya al borde de un acantilado caribeño, seguida de una de las playas más bellas del planeta.',
    fullDescription: 'Por la Carretera Federal 307 al sur de Cancún. El Castillo de Tulum se alza majestuoso sobre aguas turquesas resplandecientes rodeado de iguanas y palmeras. Al terminar la visita arqueológica, maneja 5 minutos hacia Playa Paraíso o Playa Pescadores para refrescarte y disfrutar de mariscos frescos.',
    image: imgTulum,
    distanceFromCancun: '130 km al sur de Cancún (1h 45m en auto)',
    drivingTimeMinutes: 105,
    whyByCar: 'Un traslado privado o taxi cobra más de $2,500 MXN ida y vuelta. Con tu auto de Easy Way manejas relajado por una excelente carretera, sales cuando quieres y te quedas en la playa el tiempo que te plazca.',
    parkingInfo: 'Estacionamiento habilitado del Parque Nacional Tulum ($100 MXN día) y clubes de playa.',
    bestTime: '08:00 AM (antes del calor fuerte y los autobuses turísticos)',
    priceRange: '$$',
    rating: 5.0,
    highlight: 'Pirámides mayas sobre acantilados de agua turquesa',
    mapQuery: 'Tulum Archaeological Zone'
  },
  {
    id: 'coba-cenotes-selva',
    title: 'Cobá & Cenotes Subterráneos de la Selva',
    category: 'roadtrips',
    tag: 'Excursión Foránea (Selva Maya)',
    shortDescription: 'Pedalea en bicicleta bajo la densa selva hasta la pirámide Nohoch Mul y nada en cenotes de bóveda cerrada.',
    fullDescription: 'Cobá es una de las metrópolis mayas más extensas y misteriosas, conectada por caminos de piedra blanca (sacbés). Puedes rentar una bicicleta para recorrer sus senderos sombreados. Muy cerca se encuentran tres cenotes subterráneos increíbles (Cho-Ha, Tamcach-Ha y Multum-Ha) con estalactitas gigantes.',
    image: imgCoba,
    distanceFromCancun: '135 km al suroeste de Cancún (1h 50m en auto)',
    drivingTimeMinutes: 110,
    whyByCar: 'Llegar en transporte colectivo a Cobá y luego a los cenotes de la selva es sumamente complicado. Con tu auto es un roadtrip fabuloso por carreteras tranquilas y asfaltadas.',
    parkingInfo: 'Estacionamiento amplio junto a la laguna de Cobá ($60 MXN).',
    bestTime: '08:30 AM - 01:00 PM',
    priceRange: '$$',
    rating: 4.9,
    highlight: 'Pirámides ancestrales envueltas por la selva tropical',
    mapQuery: 'Coba Archaeological Site'
  },
  {
    id: 'puerto-morelos-ruta-cenotes-roadtrip',
    title: 'Puerto Morelos: Pueblo de Pescadores & Arrecife',
    category: 'roadtrips',
    tag: 'Excursión Foránea Inmediata',
    shortDescription: 'Encanto caribeño auténtico, el faro inclinado, restaurantes de mariscos a la orilla del mar y Parque Nacional Marino.',
    fullDescription: 'A solo 30 minutos al sur de Cancún. Puerto Morelos conserva la paz y la arquitectura tradicional de los pueblos costeros de antaño. Su arrecife es Parque Nacional Marino y cuenta con excelente snorkel a 400 metros de la orilla, así como el punto de inicio de la Ruta de los Cenotes.',
    image: imgPuertoMorelos,
    distanceFromCancun: '36 km al sur de Cancún (30 min en auto)',
    drivingTimeMinutes: 30,
    whyByCar: 'Es la escapada de medio día perfecta desde Cancún. Llegas en media hora por la Carretera 307 y disfrutas de mariscos frescos frente al mar sin prisas.',
    parkingInfo: 'Estacionamiento público gratuito junto al zócalo y muelle del faro inclinado.',
    bestTime: '10:00 AM - 05:00 PM',
    priceRange: '$',
    rating: 4.8,
    highlight: 'Faro inclinado histórico, ceviche fresco y arrecife protegido',
    mapQuery: 'Puerto Morelos Quintana Roo'
  },

  // --- GASTRONOMÍA & MERCADOS LOCALES DE CANCÚN ---
  {
    id: 'parque-de-las-palapas-cancun',
    title: 'Parque de las Palapas: Antojitos & Marquesitas',
    category: 'gastronomia',
    tag: 'Local Cancún & Sabor Popular',
    shortDescription: 'El corazón gastronómico tradicional de Cancún: marquesitas crujientes, panuchos yucatecos, tacos y música en vivo.',
    fullDescription: 'Para saborear la gastronomía mexicana real lejos de los precios turísticos de los hoteles, la plaza de las Palapas es el punto de reunión obligado de las familias cancunenses. Prueba tacos de cochinita pibil, empanadas de cazón, elotes asados y de postre una deliciosa marquesita rellena de queso de bola y Nutella.',
    image: imgParquePalapas,
    distanceFromCancun: 'Centro de Cancún (Supermanzana 22)',
    drivingTimeMinutes: 7,
    whyByCar: 'Estaciona tu auto en las calles aledañas y recorre el centro histórico con total seguridad y confort.',
    parkingInfo: 'Estacionamiento público en calles circundantes y plazas comerciales cercanas.',
    bestTime: '06:00 PM - 11:30 PM (cuando la plaza se llena de vida familiar y puestos)',
    priceRange: '$',
    rating: 4.8,
    highlight: 'Marquesitas tradicionales de queso de bola y antojitos yucatecos auténticos',
    mapQuery: 'Parque de las Palapas Cancun'
  },
  {
    id: 'mariscos-mercado-28',
    title: 'Marisquerías del Mercado 28 (El Cejas)',
    category: 'gastronomia',
    tag: 'Local Cancún & Mariscos Caribeños',
    shortDescription: 'Ceviches colosales, filetes al mojo de ajo, micheladas heladas y marimba en vivo en el centro de Cancún.',
    fullDescription: 'Ubicadas en el patio central del Mercado 28 con más de 30 años de tradición. Célebres por sus porciones generosas de mariscos frescos del Golfo y Caribe: cocteles de camarón y pulpo, tostadas de jaiba, empanadas de camarón con queso y cazuelas de mariscos amenizadas por grupos de marimba y son jarocho.',
    image: imgMariscosMercado28,
    distanceFromCancun: 'Centro de Cancún (Supermanzana 28)',
    drivingTimeMinutes: 8,
    whyByCar: 'Combina tu comida de mariscos con tus compras de artesanías dejando tus paquetes en la cajuela del auto.',
    parkingInfo: 'Estacionamiento propio vigilado del Mercado 28.',
    bestTime: '12:30 PM - 05:00 PM',
    priceRange: '$$',
    rating: 4.8,
    highlight: 'Ceviches caribeños colosales y música en vivo de marimba',
    mapQuery: 'El Cejas Mercado 28 Cancun'
  },
  {
    id: 'el-fogon-tacos-foraneo',
    title: 'El Fogón (Tacos al Pastor en Playa del Carmen)',
    category: 'gastronomia',
    tag: 'Excursión Foránea (Playa del Carmen)',
    shortDescription: 'La taquería más famosa y aclamada de la Riviera Maya: tacos al pastor con piña, gringas y quesos fundidos.',
    fullDescription: 'Si realizas una excursión de compras o playa hacia Playa del Carmen, una parada indispensable es El Fogón. Los trompos gigantes de carne al pastor marinada giran sobre carbón al rojo vivo. Sus aguas de horchata casera y chaya con piña son legendarias.',
    image: imgTacosPastor,
    distanceFromCancun: '68 km al sur de Cancún (55 min en auto)',
    drivingTimeMinutes: 55,
    whyByCar: 'Con tu auto puedes visitarlo cómodamente al terminar tu paseo por la Quinta Avenida antes de regresar a Cancún.',
    parkingInfo: 'Estacionamiento sobre Av. 30 con parquímetro económico ($10 MXN/hora).',
    bestTime: '01:00 PM - 03:30 PM o después de las 08:00 PM',
    priceRange: '$',
    rating: 4.9,
    highlight: 'Tacos al pastor legendarios con piña y salsas caseras',
    mapQuery: 'El Fogon Playa del Carmen'
  }
];

export const CATEGORIES: { id: Attraction['category'] | 'todos'; label: string; icon: string }[] = [
  { id: 'todos', label: 'Todos los Lugares', icon: 'Sparkles' },
  { id: 'playas', label: 'Playas Icónicas', icon: 'Palmtree' },
  { id: 'cenotes', label: 'Cenotes Místicos', icon: 'Droplets' },
  { id: 'vida-nocturna', label: 'Vida Nocturna & Fiestas', icon: 'PartyPopper' },
  { id: 'shopping', label: 'Shopping & Paseos', icon: 'ShoppingBag' },
  { id: 'roadtrips', label: 'Roadtrips en Auto', icon: 'Car' },
  { id: 'gastronomia', label: 'Gastronomía & Mercados', icon: 'Utensils' },
];
